/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */
import { TicketType } from '@touchplan/common';

export enum TicketTypeUpdateStatus {
	TaskUpdateStatusDialogForMobile = 'taskupdatestatusdialogformobile',
	TaskUpdateStatusDialogForDesktop = 'taskupdatestatusdialogfordesktop',
	MilestoneUpdateStatusDialogForMobile = 'milestoneupdatestatusdialogformobile',
	MilestoneUpdateStatusDialogForDesktop = 'milestoneupdatestatusdialogfordesktop',
	ConstraintUpdateStatusDialog = 'constraintupdatestatusdialog',
	// BEGIN PLACEHOLDER REPLACE AS PART OF TP-4914
	MasterScheduleTask = 'masterScheduleTask', //TODO: move to common's ticket type
	// END PLACEHOLDER REPLACE AS PART OF TP-4914
}

export type TicketTypeCombined = TicketType | TicketTypeUpdateStatus;
